/**
 * What a successful write means for what this browser has remembered.
 * Pure, with no imports, so it can be tested without a browser. The effects
 * themselves are in lib/freshAfterWrite.js.
 *
 * `sweep`: forget remembered pages. Every write, because a page's data can
 * depend on a setting saved somewhere else (the quote page on the quote layout)
 * and no save can know all its readers.
 * The other three are read once per page load, outside the query cache.
 */
const NOT_A_CHANGE = [
  /^\/auth\//,
  /\/track-pdf-download(\/|$)/,
  /\/engagement(\/|$)/,
  /\/reveal(\/|$)/,
];

const FLAGS = [/^\/admin\/feature-flags(\/|$)/, /^\/admin\/companies\/[^/]+\/feature-flags(\/|$)/];
const BRANDING = [/^\/admin\/portal-settings(\/|$)/, /^\/admin\/branding(\/|$)/, /^\/admin\/domains(\/|$)/];
const ACCOUNT = [/^\/admin\/roles(\/|$)/, /^\/admin\/users(\/|$)/];

const matches = (patterns, path) => patterns.some((p) => p.test(path));

/** @returns {{ sweep: boolean, flags: boolean, branding: boolean, account: boolean }} */
export function effectsOfWrite(method, url) {
  const none = { sweep: false, flags: false, branding: false, account: false };
  const verb = String(method || 'get').toLowerCase();
  if (!['post', 'put', 'patch', 'delete'].includes(verb)) return none;
  const path = String(url || '').replace(/^https?:\/\/[^/]+/i, '').replace(/^\/api(?=\/)/, '').split('?')[0];
  if (matches(NOT_A_CHANGE, path)) return none;
  return {
    sweep: true,
    flags: matches(FLAGS, path),
    branding: matches(BRANDING, path),
    account: matches(ACCOUNT, path),
  };
}
